import { Controller } from "@hotwired/stimulus"
import Collapse from 'bootstrap/js/dist/collapse'

export default class extends Controller {
  connect() {
    this.element.querySelectorAll('.collapse').forEach(e => new Collapse(e, { toggle: false }))
  }
}
